module.exports = __webpack_public_path__ + "img/filter.3d7f1702.svg";